import { useEffect, useState } from 'react'
import { fetchGrowthEngineRecommendations } from 'src/utils/growthEngineApi'

const EMPTY_PAGE = Object.freeze({
  guidedSuccess: null,
  recommendation: null,
  plan: null,
  ladder: null,
})

/**
 * Feature-page Guided Success + picker recommendation from Express.
 * Do not invent empty state / suggested data from featureId.
 */
export function useGrowthEngineFeaturePage({
  venueId,
  surface,
  featureId,
  product,
} = {}) {
  const [payload, setPayload] = useState(EMPTY_PAGE)

  useEffect(() => {
    if (!venueId || !surface) {
      setPayload(EMPTY_PAGE)
      return undefined
    }

    let cancelled = false

    fetchGrowthEngineRecommendations(venueId, {
      platform: 'dashboard',
      surface,
      ...(featureId ? { featureId } : {}),
      ...(product ? { product } : {}),
    })
      .then(result => {
        if (cancelled) return null
        setPayload({
          guidedSuccess: result.guidedSuccess || null,
          recommendation: result.recommendation || null,
          plan: result.plan || null,
          ladder: result.ladder || null,
        })
        return result
      })
      .catch(err => {
        console.warn('Growth Engine feature guidance failed', err)
        if (!cancelled) {
          setPayload(EMPTY_PAGE)
        }
      })

    return () => {
      cancelled = true
    }
  }, [venueId, surface, featureId, product])

  return payload
}

/**
 * Feature-page Guided Success payload from Express.
 * Do not invent empty state / suggested data from featureId.
 */
export default function useGrowthEngineFeatureGuidance(args) {
  return useGrowthEngineFeaturePage(args).guidedSuccess
}
